import React from 'react'
import PropTypes from 'prop-types'

const LengthRows = (props) => {
    const rows = props.data.map((row, i) => <td key={'length-' + i}>{ row ? row: ''}</td>);
    return (
        <tr key={'length-row'}>
            <th key={'length-header'}>Length</th>
            {rows}
        </tr>
    )
};

LengthRows.props = {
    data: PropTypes.array.isRequired
};
export default LengthRows;